import { render, staticRenderFns } from "./DocumentsListMember.vue?vue&type=template&id=8443a062&scoped=true&"
import script from "./DocumentsListMember.vue?vue&type=script&lang=js&"
export * from "./DocumentsListMember.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListMember.vue?vue&type=style&index=0&id=8443a062&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8443a062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
